import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=f4f71e2c&"
import script from "./Application.vue?vue&type=script&lang=js&"
export * from "./Application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports